import { config } from '@shakkerai/config';
import { loraBestAllStructrues as MO, loraTool as MOT } from './mainlandOnline';
import { loraBestAllStructrues as OO, loraTool as OOT } from './overseasOnline';
import { loraBestAllStructrues as MT, loraTool as MTT } from './mainlandTest';

const justifyEnv = () => {
  const host = config.apiHost ?? '';
  const testEnvFlag = /www-test/g;
  if (testEnvFlag.test(host)) {
    return {
      tool: MTT,
      classify: MT,
    };
  }
  if (config.env === 'aws') {
    return {
      tool: OOT,
      classify: OO,
    };
  }
  // 国内
  return {
    tool: MOT,
    classify: MO,
  };
};

const LoraToolEnv = justifyEnv();

export default LoraToolEnv;

// export const findClassConfig = (arr, categories) => {
export const findClassConfig = (arr) => {
  let target = {};
  const cl = LoraToolEnv.classify.filter((cl) => arr.some((d) => d === cl.codes));
  if (cl.length === 0) {
    return target;
  }
  if (cl[0].codes === '100028') {
    target = arr.some((d) => d === '100048') ? cl[0] : cl[1];
  } else {
    target = cl[0];
  }
  return target;
};
